import { render, staticRenderFns } from "./FlightsList.vue?vue&type=template&id=59b5939c"
import script from "./FlightsList.vue?vue&type=script&lang=js"
export * from "./FlightsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsLoading: require('/home/forge/ab.farescraper.com/components/FlightsLoading.vue').default,VerifiedResults: require('/home/forge/ab.farescraper.com/components/VerifiedResults.vue').default,SponsoredResults: require('/home/forge/ab.farescraper.com/components/SponsoredResults.vue').default})
